<template>
  <div>
    <div
      v-if="openMobileNav"
      class="flex flex-col fixed z-10 bg-[#1A1A1D] w-full h-full right-0"
    >
      <div class="relative flex items-center justify-center w-full h-full">
        <div @click="toggleMobileNav" class="absolute top-4 right-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="#878787"
            class="w-6 h-6 cursor-pointer"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <div class="flex justify-center items-center flex-col text-2xl">
          <MobileMenutItem
            :href="'#about'"
            :link-name="'About'"
            @click="toggleMobileNav"
          />
          <MobileMenutItem
            :href="'#projects'"
            :link-name="'Projects'"
            @click="toggleMobileNav"
          />
          <MobileMenutItem
            :href="'#skills'"
            :link-name="'Skills'"
            @click="toggleMobileNav"
          />
          <MobileMenutItem
            :href="'#contact'"
            :link-name="'Contact'"
            @click="toggleMobileNav"
          />
          <!-- <a class="p-4 mb-2" href="#work" @click="toggleMobileNav"
            >Experience</a
          > -->
        </div>
      </div>
    </div>
    <section id="about" class="bg-[#1A1A1D]">
      <div
        id="nav"
        class="fixed w-full bg-[#1A1A1D] flex flex-row justify-between p-4"
        style="z-index: 1"
      >
        <div>
          <a class="prompt-bold hover:text-[#e4e4e4] text-[#a6a6a6]" href="#"
            >SP</a
          >
        </div>
        <nav class="hidden md:flex">
          <MenuItem :href="'#about'" :link-name="'About'" />
          <MenuItem :href="'#projects'" :link-name="'Projects'" />
          <MenuItem :href="'#skills'" :link-name="'Skills'" />
          <MenuItem :href="'#contact'" :link-name="'Contact'" />
        </nav>
        <nav class="flex md:hidden">
          <div @click="toggleMobileNav">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#878787"
              class="w-6 h-6 cursor-pointer"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </div>
        </nav>
      </div>
      <div
        class="flex justify-center items-center flex-col md:items-start about-container"
      >
        <div class="flex flex-col-reverse md:flex-row m-auto">
          <div class="m-8 md:mr-12">
            <h1 class="text-[35px] md:text-[60px] prompt-bold text-[#e4e4e4]">
              Shree Patel
            </h1>
            <h2 class="text-[20px] md:text-2xl text-[#E966A0]">
              Software Engineer
            </h2>
            <p
              class="text-[14px] md:text-[16px] max-w-sm md:max-w-lg pt-2 font-light text-[#a6a6a6]"
            >
              A frontend focused full stack software engineer with 5 years of
              professional experience. Experienced in HTML, CSS, JavaScript,
              Vue, and Java. A fast learner with the ability to adapt to new
              technologies and bring bring results.
            </p>
          </div>
          <img
            src="../assets/images/devpichome.jpg"
            alt="Avatar"
            class="hidden md:block about-pic object-cover object-right shadow-md"
          />
        </div>
      </div>
    </section>
    <section id="projects" class="bg-[#1A1A1D]">
      <div class="m-auto pb-4">
        <h2 class="p-4 text-xl font-semibold text-center text-[#e4e4e4]">
          Personal Projects
        </h2>
        <div class="grid justify-center m-5">
          <span class="text-center text-[#e4e4e4]">Newest</span>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a
                href="https://flashcard-5b96d8b5ce3b.herokuapp.com/"
                target="_blank"
              >
                <img src="../assets/images/flashcards.png" alt="fin" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">
                  Flashcards
                </h4>
                <div class="flex items-center py-2 pr-2">
                  <a
                    href="https://flashcard-5b96d8b5ce3b.herokuapp.com/"
                    class="mr-3"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="20"
                      height="20"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://github.com/RosePatels/Flashcard-backend"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">Full Stack Flashcard Study App</p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Vue
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Pinia
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Java
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Spring Boot
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Responsive
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a
                href="https://fin-shreedev-35fe841f809e.herokuapp.com/"
                target="_blank"
              >
                <img src="../assets/images/fin-app.png" alt="fin" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">Fin</h4>
                <div class="flex items-center py-2 pr-2">
                  <a
                    href="https://fin-shreedev-35fe841f809e.herokuapp.com/"
                    class="mr-3"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="20"
                      height="20"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://github.com/RosePatels/fin-frontend"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">Full Stack Finance Budgeting app</p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Vue
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Pinia
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Java
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Spring Boot
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Responsive
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a href="https://mastermind-dev.netlify.app/" target="_blank">
                <img src="../assets/images/mastermind.png" alt="Tack" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">
                  Mastermind
                </h4>
                <div class="flex items-center py-2 pr-2">
                  <a
                    href="https://mastermind-dev.netlify.app/"
                    class="mr-3"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="20"
                      height="20"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://github.com/RosePatels/Mastermind"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">Clone of Mastermind board game</p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    HTML
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    CSS
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    JavaScript
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Vue
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Pinia
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a
                href="https://storefront-shreedev.herokuapp.com"
                target="_blank"
              >
                <img src="../assets/images/Storefront.png" alt="Tack" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">
                  Storefront
                </h4>
                <div class="flex items-center py-2 pr-2">
                  <a
                    href="https://storefront-shreedev.herokuapp.com"
                    class="mr-3"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="20"
                      height="20"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://github.com/RosePatels/storefront"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">E-Commerce Full Stack App</p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    MongoDB
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Express
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Vue
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Node.JS
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Pinia
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a href="https://rosepatels.github.io/Jump/" target="_blank">
                <img src="../assets/images/jump.png" alt="Tack" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">Jump</h4>
                <div class="flex items-center py-2 pr-2">
                  <a
                    href="https://rosepatels.github.io/Jump/"
                    class="mr-3"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="20"
                      height="20"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                      />
                    </svg>
                  </a>
                  <a href="https://github.com/RosePatels/Jump" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">Clone of popular mobile game, Doodle Jump</p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    HTML Canvas
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    CSS
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    JavaScript
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a href="https://rosepatels.github.io/CSSDemos/" target="_blank">
                <img src="../assets/images/cssdemos.png" alt="Tack" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">
                  CSS Demos
                </h4>
                <div class="flex items-center py-2 pr-2">
                  <a
                    href="https://rosepatels.github.io/CSSDemos/"
                    class="mr-3"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="20"
                      height="20"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://github.com/RosePatels/CSSDemos"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">Showcase of CSS and Javascript animations</p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    CSS
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    JavaScript
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a href="https://github.com/steebuu/Rations" target="_blank">
                <img src="../assets/images/rations.png" alt="Tack" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">
                  Rations
                </h4>
                <div class="flex items-center py-2 pr-2">
                  <a href="https://github.com/steebuu/Rations" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">
                  Generates recipes based off ingredients using Spoonacular API
                </p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    MongoDB
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Express
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    React
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Node.JS
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article
            class="project-container grid-cols-1 md:grid-cols-2 items-center lg:items-start lg:justify-center lg:flex-row py-4 lg:py-2"
          >
            <div class="shadow">
              <a href="https://github.com/RosePatels/Tack" target="_blank">
                <img src="../assets/images/tack.png" alt="Tack" />
              </a>
            </div>
            <div
              class="pl-5 pr-2 py-2 bg-white project-info-grid self-stretch shadow"
            >
              <div class="flex justify-between items-start">
                <h4 class="font-medium py-2 text-[20px] project-name">Tack</h4>
                <div class="flex items-center py-2 pr-2">
                  <a href="https://github.com/RosePatels/Tack" target="_blank">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 496 512"
                      width="25"
                      height="25"
                      fill="#a6a6a6"
                    >
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                      <path
                        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div class="grid items-center">
                <p class="pb-2">Pixel perfect full stack clone of Slack</p>
                <div class="flex flex-wrap items-center">
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    React
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Redux
                  </div>
                  <div
                    class="px-2 py-2 mr-2 my-1 rounded-md technology-tag font-medium shadow"
                  >
                    Ruby on Rails
                  </div>
                </div>
              </div>
            </div>
          </article>
          <span class="text-center text-[#e4e4e4]">Oldest</span>
        </div>
        <!-- <div class="px-5 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3"> -->
        <!-- <article class="col-span-1 p-2">
            <div class="p-2 md:p-5">
              <div>
                <a href="https://tack-aa.herokuapp.com/" target="_blank">
                  <img src="../assets/images/tack.png" alt="Tack" />
                </a>
              </div>
              <div class="pl-2">
                <h4 class="font-medium py-2">Tack</h4>
                <p class="pb-2">Pixel perfect clone of Slack</p>
                <div class="pb-2">React Redux Ruby on Rails</div>
                <div class="flex justify-between pt-3 pr-2">
                  <a href="https://tack-aa.herokuapp.com/" target="_blank">
                    Live
                  </a>
                  <a href="https://github.com/RosePatels/Tack" target="_blank">
                    GitHub
                  </a>
                </div>
              </div>
            </div>
          </article> -->
        <!-- <article class="col-span-1 p-2">
            <div class="p-2 md:p-5">
              <div>
                <a href="https://github.com/steebuu/Rations" target="_blank">
                  <img src="../assets/images/rations.png" alt="Rations" />
                </a>
              </div>
              <div class="pl-2">
                <h4 class="font-medium py-2">Rations</h4>
                <p class="pb-2">Generates recipes based off ingredients</p>
                <div class="pb-2">MongoDB Express React Node.JS</div>
                <div class="flex justify-end pt-3 pr-2">
                  <a href="https://github.com/steebuu/Rations" target="_blank">
                    GitHub
                  </a>
                </div>
              </div>
            </div>
          </article> -->
        <!-- <article class="col-span-1 p-2">
            <div class="p-2 md:p-5">
              <div>
                <a
                  href="https://rosepatels.github.io/CSSDemos/"
                  target="_blank"
                >
                  <img src="../assets/images/cssdemos.png" alt="CSS Demos" />
                </a>
              </div>
              <div class="pl-2">
                <h4 class="font-medium py-2">CSS Demos</h4>
                <p class="pb-2">CSS and JS animations</p>
                <div class="pb-2">Vanilla CSS Vanilla JS</div>
                <div class="flex justify-between pt-3 pr-2">
                  <a
                    href="https://rosepatels.github.io/CSSDemos/"
                    target="_blank"
                  >
                    Live
                  </a>
                  <a
                    href="https://github.com/RosePatels/CSSDemos"
                    target="_blank"
                  >
                    GitHub
                  </a>
                </div>
              </div>
            </div>
          </article> -->
        <!-- <article class="col-span-1 p-2">
            <div class="p-2 md:p-5">
              <div>
                <a href="https://rosepatels.github.io/Jump/" target="_blank">
                  <img src="../assets/images/jump.png" alt="Jump" />
                </a>
              </div>
              <div class="pl-2">
                <h4 class="font-medium py-2">Jump</h4>
                <p class="pb-2">Simple clone of Doodle Jump</p>
                <div class="pb-2">HTML canvas Vanilla CSS Vanilla JS</div>
                <div class="flex justify-between pt-3 pr-2">
                  <a href="https://rosepatels.github.io/Jump/" target="_blank">
                    Live
                  </a>
                  <a href="https://github.com/RosePatels/Jump" target="_blank">
                    GitHub
                  </a>
                </div>
              </div>
            </div>
          </article> -->
        <!-- </div> -->
      </div>
    </section>
    <section id="skills" class="bg-[#1A1A1D]">
      <div class="max-w-[900px] m-auto pb-4">
        <h2 class="text-xl font-semibold text-center text-[#e4e4e4]">Skills</h2>
        <div class="flex px-4">
          <ul
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
          >
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  fill="#E44D26"
                  d="M27.854 116.354l-8.043-90.211h88.378l-8.051 90.197-36.192 10.033z"
                ></path>
                <path
                  fill="#F16529"
                  d="M64 118.704l29.244-8.108 6.881-77.076H64z"
                ></path>
                <path
                  fill="#EBEBEB"
                  d="M64 66.978H49.359l-1.01-11.331H64V44.583H36.257l.264 2.969 2.72 30.489H64zm0 28.733l-.049.013-12.321-3.328-.788-8.823H39.735l1.55 17.372 22.664 6.292.051-.015z"
                ></path>
                <path
                  fill="#fff"
                  d="M28.034 1.627h5.622v5.556H38.8V1.627h5.623v16.822H38.8v-5.633h-5.143v5.633h-5.623V1.627zm23.782 5.579h-4.95V1.627h15.525v5.579h-4.952v11.243h-5.623V7.206zm13.039-5.579h5.862l3.607 5.911 3.603-5.911h5.865v16.822h-5.601v-8.338l-3.867 5.981h-.098l-3.87-5.981v8.338h-5.502V1.627zm21.736 0h5.624v11.262h7.907v5.561H86.591V1.627z"
                ></path>
                <path
                  fill="#fff"
                  d="M63.962 66.978v11.063h13.624L76.302 92.39l-12.34 3.331v11.51l22.682-6.286.166-1.87 2.6-29.127.27-2.97h-2.982zm0-22.395v11.064h26.725l.221-2.487.505-5.608.265-2.969z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">HTML</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  fill="#1572B6"
                  d="M18.814 114.123L8.76 1.352h110.48l-10.064 112.754-45.243 12.543-45.119-12.526z"
                ></path>
                <path
                  fill="#33A9DC"
                  d="M64.001 117.062l36.559-10.136 8.601-96.354h-45.16v106.49z"
                ></path>
                <path
                  fill="#fff"
                  d="M64.001 51.429h18.302l1.264-14.163H64.001V23.435h34.682l-.332 3.711-3.4 38.114h-30.95V51.429z"
                ></path>
                <path
                  fill="#EBEBEB"
                  d="M64.083 87.349l-.061.018-15.403-4.159-.985-11.031H33.752l1.937 21.717 28.331 7.863.063-.018v-14.39z"
                ></path>
                <path
                  fill="#fff"
                  d="M81.127 64.675l-1.666 18.522-15.426 4.164v14.39l28.354-7.858.208-2.337 2.406-26.881H81.127z"
                ></path>
                <path
                  fill="#EBEBEB"
                  d="M64.048 23.435v13.831H30.64l-.277-3.108-.63-7.012-.331-3.711h34.646zm-.047 27.996v13.831H48.792l-.277-3.108-.631-7.012-.33-3.711h16.447z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">CSS</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  fill="#F0DB4F"
                  d="M1.408 1.408h125.184v125.185H1.408z"
                ></path>
                <path
                  fill="#323330"
                  d="M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zM69.462 58.943H57.753l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">JavaScript</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path fill="#fff" d="M22.67 47h99.67v73.67H22.67z"></path>
                <path
                  data-name="original"
                  fill="#007acc"
                  d="M1.5 63.91v62.5h125v-125H1.5zm100.73-5a15.56 15.56 0 017.82 4.5 20.58 20.58 0 013 4c0 .16-5.4 3.81-8.69 5.85-.12.08-.6-.44-1.13-1.23a7.09 7.09 0 00-5.87-3.53c-3.79-.26-6.23 1.73-6.21 5a4.58 4.58 0 00.54 2.34c.83 1.73 2.38 2.76 7.24 4.86 8.95 3.85 12.78 6.39 15.16 10 2.66 4 3.25 10.46 1.45 15.24-2 5.2-6.9 8.73-13.83 9.9a38.32 38.32 0 01-9.52-.1 23 23 0 01-12.72-6.63c-1.15-1.27-3.39-4.58-3.25-4.82a9.34 9.34 0 011.15-.73L82 101l3.59-2.08.75 1.11a16.78 16.78 0 004.74 4.54c4 2.1 9.46 1.81 12.16-.62a5.43 5.43 0 00.69-6.92c-1-1.39-3-2.56-8.59-5-6.45-2.78-9.23-4.5-11.77-7.24a16.48 16.48 0 01-3.43-6.25 25 25 0 01-.22-8c1.33-6.23 6-10.58 12.82-11.87a31.66 31.66 0 019.49.26zm-29.34 5.24v5.12H56.66v46.23H45.15V69.26H28.88v-5a49.19 49.19 0 01.12-5.17C29.08 59 39 59 51 59h21.83z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">TypeScript</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  d="M0 8.934l49.854.158 14.167 24.47 14.432-24.47L128 8.935l-63.834 110.14zm126.98.637l-24.36.02-38.476 66.053L25.691 9.592.942 9.572l63.211 107.89zm-25.149-.008l-22.745.168-15.053 24.647L49.216 9.73l-22.794-.168 37.731 64.476zm-75.834-.17l23.002.009m-23.002-.01l23.002.01"
                  fill="none"
                ></path>
                <path
                  d="M25.997 9.393l23.002.009L64.035 34.36 79.018 9.404 102 9.398 64.15 75.053z"
                  fill="#35495e"
                ></path>
                <path
                  d="M.91 9.569l25.067-.172 38.15 65.659L101.98 9.401l25.11.026-62.966 108.06z"
                  fill="#41b883"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">Vue</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg
                height="60"
                viewBox="0 0 319 477"
                width="60"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <linearGradient id="a">
                  <stop offset="0" stop-color="#52ce63" />
                  <stop offset="1" stop-color="#51a256" />
                </linearGradient>
                <linearGradient
                  id="b"
                  x1="55.342075%"
                  x2="42.816933%"
                  xlink:href="#a"
                  y1="0%"
                  y2="42.862855%"
                />
                <linearGradient
                  id="c"
                  x1="55.348642%"
                  x2="42.808103%"
                  xlink:href="#a"
                  y1="0%"
                  y2="42.862855%"
                />
                <linearGradient
                  id="d"
                  x1="50%"
                  x2="50%"
                  y1="0%"
                  y2="58.811243%"
                >
                  <stop offset="0" stop-color="#8ae99c" />
                  <stop offset="1" stop-color="#52ce63" />
                </linearGradient>
                <linearGradient
                  id="e"
                  x1="51.37763%"
                  x2="44.584719%"
                  y1="17.472551%"
                  y2="100%"
                >
                  <stop offset="0" stop-color="#ffe56c" />
                  <stop offset="1" stop-color="#ffc63a" />
                </linearGradient>
                <g
                  fill="none"
                  fill-rule="evenodd"
                  transform="translate(-34 -24)"
                >
                  <g
                    transform="matrix(.99254615 .12186934 -.12186934 .99254615 33.922073 .976691)"
                  >
                    <path
                      d="m103.950535 258.274149c44.361599-4.360825 60.014503-40.391282 65.353094-94.699444s-30.93219-103.451001-46.020347-101.9678079c-15.088156 1.4831932-63.0385313 58.9051239-68.3771222 113.2132869-5.3385908 54.308162 4.6827754 87.814791 49.0443752 83.453965z"
                      fill="url(#b)"
                      transform="matrix(.70710678 -.70710678 .70710678 .70710678 -80.496332 125.892944)"
                    />
                    <path
                      d="m275.876752 258.273992c44.3616 4.360826 53.167133-29.265322 47.828542-83.573485-5.338591-54.308162-52.073133-111.6105744-67.16129-113.0937675-15.088156-1.4831931-52.57477 47.5401275-47.236179 101.8482895s22.207328 90.458137 66.568927 94.818963z"
                      fill="url(#c)"
                      transform="matrix(.70710678 .70710678 -.70710678 .70710678 191.403399 -141.861963)"
                    />
                    <path
                      d="m188.370027 216.876305c39.941834 0 50.95265-38.251987 50.95265-97.89874 0-59.6467532-37.367733-118.10125956-50.95265-118.10125956s-52.04735 58.45450636-52.04735 118.10125956c0 59.646753 12.105516 97.89874 52.04735 97.89874z"
                      fill="url(#d)"
                    />
                  </g>
                  <path
                    d="m184.473473 501c83.118854 0 150.526527-24.145148 150.526527-133.645148s-67.407673-199.354852-150.526527-199.354852c-83.118855 0-150.473473 89.854852-150.473473 199.354852s67.354618 133.645148 150.473473 133.645148z"
                    fill="url(#e)"
                  />
                  <ellipse
                    cx="260.5"
                    cy="335"
                    fill="#eaadcc"
                    rx="21.5"
                    ry="10"
                  />
                  <ellipse
                    cx="102.5"
                    cy="329"
                    fill="#eaadcc"
                    rx="21.5"
                    ry="10"
                    transform="matrix(.99254615 .12186934 -.12186934 .99254615 40.859033 -10.039292)"
                  />
                  <g
                    transform="matrix(-.99939083 .0348995 .0348995 .99939083 269.284825 271.027667)"
                  >
                    <path
                      d="m73.1046985 58.2728794c6.7372416 4.9130333 14.3132632 6.6640587 22.7280649 5.2530761 8.4148016-1.4109825 14.5054466-5.2535769 18.2719346-11.527783"
                      stroke="#000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="6"
                      transform="matrix(.9998477 .01745241 -.01745241 .9998477 1.026464 -1.624794)"
                    />
                    <path
                      d="m154.501124 3c-5.937545 0-11.312782 2.40629805-15.203644 6.29680621-3.89094 3.89058529-6.29748 9.26545449-6.29748 15.20263179 0 5.9376888 2.406488 11.3127422 6.297291 15.2034272 3.890886 3.8907673 9.266197 6.2971348 15.203833 6.2971348 5.937109 0 11.311896-2.4063889 15.202387-6.2972348 3.890299-3.8906535 6.296489-9.2656636 6.296489-15.2033272 0-5.9371521-2.406242-11.3119781-6.296677-15.20253181-3.890469-3.89058674-9.265181-6.29690619-15.202199-6.29690619z"
                      fill="#000"
                    />
                    <path
                      d="m154 21c0-3.865549 3.135362-7 6.999413-7 3.866399 0 7.000587 3.134451 7.000587 7s-3.134188 7-7.000587 7c-3.864051-.0011735-6.999413-3.134451-6.999413-7z"
                      fill="#fff"
                    />
                    <path
                      d="m24.5 13c-5.9375292 0-11.312426 2.406268-15.20299427 6.2967181-3.89069464 3.8905765-6.29700573 9.2654765-6.29700573 15.2027199 0 5.9377549 2.40625962 11.3128391 6.29681766 15.2035153 3.89059104 3.8907092 9.26556184 6.2970467 15.20318234 6.2970467 5.9371249 0 11.3122514-2.406419 15.2030371-6.2973229 3.8905441-3.8906623 6.2969629-9.2656416 6.2969629-15.2032391 0-5.937086-2.4064703-11.3118811-6.297151-15.2024437-3.890763-3.8906448-9.2658154-6.2969943-15.202849-6.2969943z"
                      fill="#000"
                    />
                    <g fill="#fff">
                      <path
                        d="m136 24.499438c0 10.2185232 8.282911 18.500562 18.501124 18.500562 10.217089 0 18.498876-8.2820388 18.498876-18.500562 0-10.2173992-8.281787-18.499438-18.498876-18.499438-10.218213 0-18.501124 8.2820388-18.501124 18.499438zm-6 0c0-13.5311954 10.96929-24.499438 24.501124-24.499438 13.530838 0 24.498876 10.9683711 24.498876 24.499438 0 13.5319607-10.967808 24.500562-24.498876 24.500562-13.532064 0-24.501124-10.9684728-24.501124-24.500562z"
                        fill-rule="nonzero"
                        stroke="#fff"
                        stroke-width="3"
                      />
                      <path
                        d="m6 34.499438c0 10.2185232 8.2817873 18.500562 18.5 18.500562 10.2170889 0 18.5-8.2820388 18.5-18.500562 0-10.2173992-8.2829111-18.499438-18.5-18.499438-10.2182127 0-18.5 8.2820388-18.5 18.499438zm-6 0c0-13.531297 10.9682681-24.499438 24.5-24.499438 13.5309398 0 24.5 10.9684728 24.5 24.499438 0 13.5318591-10.96883 24.500562-24.5 24.500562-13.531962 0-24.5-10.9683711-24.5-24.500562z"
                        fill-rule="nonzero"
                        stroke="#fff"
                        stroke-width="3"
                      />
                      <path
                        d="m24 31c0-3.865549 3.134451-7 7-7s7 3.134451 7 7-3.134451 7-7 7-7-3.134451-7-7z"
                      />
                    </g>
                  </g>
                  <g stroke-linecap="round" stroke-width="11">
                    <g stroke="#ecb732">
                      <path d="m70.5 377.5 74 77" />
                      <path d="m134.5 386.5-47 50" />
                    </g>
                    <g stroke="#ecb732" transform="matrix(-1 0 0 1 298 377)">
                      <path d="m.5.5 74 77" />
                      <path d="m64.5 9.5-47 50" />
                    </g>
                    <g stroke="#ffc73b" transform="matrix(0 1 -1 0 215 207)">
                      <path d="m.5.5 49 49" />
                      <path
                        d="m.5 10.5 49 49"
                        transform="matrix(-1 0 0 1 50 0)"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <div class="pl-4 font-medium skill-name">Pinia</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  fill="#0074BD"
                  d="M47.617 98.12s-4.767 2.774 3.397 3.71c9.892 1.13 14.947.968 25.845-1.092 0 0 2.871 1.795 6.873 3.351-24.439 10.47-55.308-.607-36.115-5.969zm-2.988-13.665s-5.348 3.959 2.823 4.805c10.567 1.091 18.91 1.18 33.354-1.6 0 0 1.993 2.025 5.132 3.131-29.542 8.64-62.446.68-41.309-6.336z"
                ></path>
                <path
                  fill="#EA2D2E"
                  d="M69.802 61.271c6.025 6.935-1.58 13.17-1.58 13.17s15.289-7.891 8.269-17.777c-6.559-9.215-11.587-13.792 15.635-29.58 0 .001-42.731 10.67-22.324 34.187z"
                ></path>
                <path
                  fill="#0074BD"
                  d="M102.123 108.229s3.529 2.91-3.888 5.159c-14.102 4.272-58.706 5.56-71.094.171-4.451-1.938 3.899-4.625 6.526-5.192 2.739-.593 4.303-.485 4.303-.485-4.953-3.487-32.013 6.85-13.743 9.815 49.821 8.076 90.817-3.637 77.896-9.468zM49.912 70.294s-22.686 5.389-8.033 7.348c6.188.828 18.518.638 30.011-.326 9.39-.789 18.813-2.474 18.813-2.474s-3.308 1.419-5.704 3.053c-23.042 6.061-67.544 3.238-54.731-2.958 10.832-5.239 19.644-4.643 19.644-4.643zm40.697 22.747c23.421-12.167 12.591-23.86 5.032-22.285-1.848.385-2.677.72-2.677.72s.688-1.079 2-1.543c14.953-5.255 26.451 15.503-4.823 23.725 0-.002.359-.327.468-.617z"
                ></path>
                <path
                  fill="#EA2D2E"
                  d="M76.491 1.587S89.459 14.563 64.188 34.51c-20.266 16.006-4.621 25.13-.007 35.559-11.831-10.673-20.509-20.07-14.688-28.815C58.041 28.42 81.722 22.195 76.491 1.587z"
                ></path>
                <path
                  fill="#0074BD"
                  d="M52.214 126.021c22.476 1.437 57-.8 57.817-11.436 0 0-1.571 4.032-18.577 7.231-19.186 3.612-42.854 3.191-56.887.874 0 .001 2.875 2.381 17.647 3.331z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">Java</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                data-name="Layer 1"
                viewBox="0 0 24 24"
                fill="#eaeaea"
                width="50"
                height="50"
              >
                <path
                  d="M24,22v1h-4V15h1v7h3Zm-12.626-3.471c-.31-.117-1.189-.466-1.523-.67-.325-.231-.477-.568-.428-.948,.053-.399,.316-.723,.687-.845,.561-.185,1.121-.008,1.768,.553l.655-.756c-.915-.793-1.835-1.045-2.736-.747-.739,.244-1.262,.881-1.366,1.666-.096,.743,.218,1.45,.88,1.917,.492,.305,1.587,.721,1.699,.763,1.052,.425,1.013,1.204,.976,1.431-.104,.641-.669,1.105-1.342,1.105-.525,0-1.348-.368-1.761-.787l-.712,.702c.526,.533,1.595,1.085,2.473,1.085,1.166,0,2.146-.818,2.33-1.945,.131-.812-.206-1.959-1.599-2.523Zm7.21,3.34l.77,.77-.707,.707-.77-.77c-.395,.262-.868,.417-1.376,.417-1.378,0-2.5-1.122-2.5-2.5v-3c0-1.378,1.122-2.5,2.5-2.5s2.5,1.122,2.5,2.5v3c0,.509-.154,.981-.417,1.376Zm-1.441-.027l-.496-.496,.707-.707,.496,.496c.094-.196,.15-.412,.15-.643v-3c0-.827-.673-1.5-1.5-1.5s-1.5,.673-1.5,1.5v3c0,.827,.673,1.5,1.5,1.5,.231,0,.447-.057,.643-.15Zm-11.143-4.055v1.017c-2.173-.343-3.959-1.12-5-2.155v2.851c0,1.49,2.122,2.794,5,3.287v1.021c-3.509-.553-6-2.247-6-4.308V4.5C0,1.977,3.733,0,8.5,0s8.5,1.977,8.5,4.5V13h-1v-1.351c-1.419,1.411-4.213,2.351-7.5,2.351s-6.081-.94-7.5-2.351v2.851c0,1.49,2.122,2.794,5,3.287ZM1,4.5c0,1.897,3.435,3.5,7.5,3.5s7.5-1.603,7.5-3.5-3.435-3.5-7.5-3.5S1,2.603,1,4.5Zm0,5c0,1.897,3.435,3.5,7.5,3.5s7.5-1.603,7.5-3.5v-2.851c-1.419,1.411-4.213,2.351-7.5,2.351s-6.081-.94-7.5-2.351v2.851Z"
                />
              </svg>

              <div class="pl-4 font-medium skill-name">SQL</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  d="M64.004 25.602c-17.067 0-27.73 8.53-32 25.597 6.398-8.531 13.867-11.73 22.398-9.597 4.871 1.214 8.352 4.746 12.207 8.66C72.883 56.629 80.145 64 96.004 64c17.066 0 27.73-8.531 32-25.602-6.399 8.536-13.867 11.735-22.399 9.602-4.87-1.215-8.347-4.746-12.207-8.66-6.27-6.367-13.53-13.738-29.394-13.738zM32.004 64c-17.066 0-27.73 8.531-32 25.602C6.402 81.066 13.87 77.867 22.402 80c4.871 1.215 8.352 4.746 12.207 8.66 6.274 6.367 13.536 13.738 29.395 13.738 17.066 0 27.73-8.53 32-25.597-6.399 8.531-13.867 11.73-22.399 9.597-4.87-1.214-8.347-4.746-12.207-8.66C55.128 71.371 47.868 64 32.004 64zm0 0"
                  fill="#38b2ac"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">Tailwind</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  fill="#F34F29"
                  d="M124.737 58.378L69.621 3.264c-3.172-3.174-8.32-3.174-11.497 0L46.68 14.71l14.518 14.518c3.375-1.139 7.243-.375 9.932 2.314 2.703 2.706 3.461 6.607 2.294 9.993l13.992 13.993c3.385-1.167 7.292-.413 9.994 2.295 3.78 3.777 3.78 9.9 0 13.679a9.673 9.673 0 01-13.683 0 9.677 9.677 0 01-2.105-10.521L68.574 47.933l-.002 34.341a9.708 9.708 0 012.559 1.828c3.778 3.777 3.778 9.898 0 13.683-3.779 3.777-9.904 3.777-13.679 0-3.778-3.784-3.778-9.905 0-13.683a9.65 9.65 0 013.167-2.11V47.333a9.581 9.581 0 01-3.167-2.111c-2.862-2.86-3.551-7.06-2.083-10.576L41.056 20.333 3.264 58.123a8.133 8.133 0 000 11.5l55.117 55.114c3.174 3.174 8.32 3.174 11.499 0l54.858-54.858a8.135 8.135 0 00-.001-11.501z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">Git</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <g id="surface1">
                  <path
                    style="
                      stroke: none;
                      fill-rule: nonzero;
                      fill: rgb(86.666667%, 0%, 19.215686%);
                      fill-opacity: 1;
                    "
                    d="M 64 15.359375 L 16.332031 32.359375 L 23.601562 95.386719 L 64 117.761719 L 104.398438 95.386719 L 111.667969 32.359375 Z M 64 15.359375 "
                  ></path>
                  <path
                    style="
                      stroke: none;
                      fill-rule: nonzero;
                      fill: rgb(76.470588%, 0%, 18.431373%);
                      fill-opacity: 1;
                    "
                    d="M 64 15.359375 L 64 26.726562 L 64 26.675781 L 64 117.761719 L 104.398438 95.386719 L 111.667969 32.359375 Z M 64 15.359375 "
                  ></path>
                  <path
                    style="
                      stroke: none;
                      fill-rule: nonzero;
                      fill: rgb(100%, 100%, 100%);
                      fill-opacity: 1;
                    "
                    d="M 64 26.675781 L 34.203125 93.492188 L 45.3125 93.492188 L 51.300781 78.539062 L 76.59375 78.539062 L 82.585938 93.492188 L 93.695312 93.492188 Z M 72.703125 69.324219 L 55.296875 69.324219 L 64 48.382812 Z M 72.703125 69.324219 "
                  ></path>
                </g>
              </svg>
              <div class="pl-4 font-medium skill-name">Angular</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <g fill="#61DAFB">
                  <circle cx="64" cy="64" r="11.4"></circle>
                  <path
                    d="M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3C8.2 50 1.4 56.6 1.4 64s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zM92.5 14.7c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zM81.3 74c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zM64 97.8c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zM64 30.2c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zM31.7 35c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zM7 64c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5C15.3 75.6 7 69.6 7 64zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zM96.3 93c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z"
                  ></path>
                </g>
              </svg>
              <div class="pl-4 font-medium skill-name">React</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path fill="none" d="M0 0h128v128H0z"></path>
                <path
                  d="M88.69 88.11c-9 18.4-24.76 30.78-45.61 34.85a39.73 39.73 0 01-9.77 1.14c-12 0-23-5-28.34-13.19C-2.2 100-4.64 76.87 19 59.76c.48 2.61 1.46 6.19 2.11 8.31A38.24 38.24 0 0010 81.1c-4.4 8.64-3.91 17.27 1.3 25.25 3.6 5.38 9.3 8.65 16.63 9.65a44 44 0 0026.55-5c12.71-6.68 21.18-14.66 26.72-25.57a9.32 9.32 0 01-2.61-6A9.12 9.12 0 0187.37 70h.34a9.15 9.15 0 011 18.25zm28.67-20.2c12.21 13.84 12.54 30.13 7.82 39.58-4.4 8.63-16 17.27-31.6 17.27a50.48 50.48 0 01-21-5.05c2.29-1.63 5.54-4.24 7.33-5.87a41.54 41.54 0 0016 3.42c10.1 0 17.75-4.72 22.31-13.35 2.93-5.7 3.1-12.38.33-19.22a43.61 43.61 0 00-17.27-20.85 62 62 0 00-34.74-10.59h-2.93a9.21 9.21 0 01-8 5.54h-.31a9.13 9.13 0 01-.3-18.25h.33a9 9 0 018 4.89h2.61c20.8 0 39.06 7.98 51.42 22.48zm-82.75 23a7.31 7.31 0 011.14-4.73c-9.12-15.8-14-35.83-6.51-56.68C34.61 13.83 48.13 3.24 62.79 3.24c15.64 0 31.93 13.69 33.88 40.07-2.44-.81-6-2-8.14-2.44-.53-8.63-7.82-30.13-25.09-29.81-6.19.17-15.31 3.1-20 9.12a43.69 43.69 0 00-9.64 25.25 59.61 59.61 0 008.47 36.16 2.75 2.75 0 011.14-.16h.32a9.12 9.12 0 01.33 18.24h-.33a9.16 9.16 0 01-9.12-8.79z"
                  fill="#764abc"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">Redux</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  fill="#C00"
                  d="M109.682 14.737c-12.206-6.023-24.708-6.636-37.508-2.111-11.779 4.164-21.175 11.615-28.16 21.763C32.195 51.561 23.61 70.298 18.799 90.652c-2.464 10.417-4.06 21.466-3.631 32.224.035.873.165 1.124.251 3.124h60.366c-.173-2-.287-1.416-.437-1.797a153.86 153.86 0 01-7.428-25.198c-2.498-12.251-3.806-24.729-1.226-37.093 3.611-17.313 13.48-29.805 30.117-36.283 9.424-3.667 18.369-2.624 26.214 4.262.072.063.22.025.412.056l2.565-3.883c-4.94-4.703-10.368-8.389-16.32-11.327zM3.336 94.394c-.46 3.923-.89 7.596-1.34 11.451l11.132 1.336 2.039-11.893-11.831-.894zm21.85-34.186l-10.471-4.097-3.384 9.607 10.671 3.42c1.08-3.031 2.096-5.882 3.184-8.93zm49.419 53.659c3.575.266 7.157.449 11.103.679-1.433-2.979-2.706-5.673-4.039-8.335-.146-.289-.639-.568-.974-.573-3.033-.044-6.068-.025-9.291-.025.726 2.628 1.357 5.053 2.096 7.443.111.361.707.782 1.105.811zM42.933 31.103l-7.955-5.268-6.359 7.105 8.178 5.496 6.136-7.333zm25.334 53.369c-.013.321.276.832.558.959 2.865 1.288 5.76 2.515 8.912 3.873-.131-2.492-.219-4.575-.368-6.654-.027-.374-.203-.912-.48-1.066-2.631-1.456-5.299-2.847-8.216-4.395-.159 2.665-.321 4.972-.406 7.283zM65.91 12.3l-5.446-6.181-7.499 3.898 5.455 6.644 7.49-4.361zm3.415 49.176c-.163.374.052 1.167.373 1.456 2.175 1.962 4.424 3.84 6.926 5.981.573-2.4 1.113-4.539 1.571-6.693.081-.383-.032-1.016-.298-1.23-1.946-1.569-3.955-3.063-6.037-4.651-.915 1.815-1.802 3.443-2.535 5.137zm12.45-52.424c2.78.075 5.563.042 8.499.042-.293-2.044-.433-3.593-.782-5.092-.104-.446-.775-1.04-1.228-1.078-2.787-.226-5.585-.313-8.651-.459.409 2.063.721 3.881 1.162 5.668.093.379.647.909 1 .919zm3.385 35.675c.142-.266.178-.749.029-.981-1.366-2.137-2.785-4.241-4.254-6.455l-4.76 4.372 6.582 7.294c.884-1.539 1.675-2.868 2.403-4.23zM90.295 30.2l2.843 5.281c4.449-2.438 4.875-3.32 3.3-6.834L90.295 30.2zm21.287-16.273c1.851 1.142 3.806 2.115 5.792 3.185l1.33-2.07c-2.422-1.771-4.76-3.484-7.413-5.426-.104 1.104-.259 1.875-.219 2.637.032.581.129 1.44.51 1.674zM109 30.646c2 .217 5 .424 7 .643v-2.718c-2-.438-5-.872-7-1.323v3.398z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">Ruby on Rails</div>
            </li>
            <li class="flex items-center p-4 m-4">
              <svg viewBox="0 0 128 128" width="50" height="50">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  fill="#D91404"
                  d="M35.971 111.33l81.958 11.188c-9.374-15.606-18.507-30.813-27.713-46.144L35.971 111.33zm89.71-86.383c-2.421 3.636-4.847 7.269-7.265 10.907a67619.72 67619.72 0 00-24.903 37.485c-.462.696-1.061 1.248-.41 2.321 8.016 13.237 15.969 26.513 23.942 39.777 1.258 2.095 2.53 4.182 4.157 6.192l4.834-96.58-.355-.102zM16.252 66.22c.375.355 1.311.562 1.747.347 7.689-3.779 15.427-7.474 22.948-11.564 2.453-1.333 4.339-3.723 6.452-5.661 6.997-6.417 13.983-12.847 20.966-19.278.427-.395.933-.777 1.188-1.275 2.508-4.902 4.973-9.829 7.525-14.898-3.043-1.144-5.928-2.263-8.849-3.281-.396-.138-1.02.136-1.449.375-6.761 3.777-13.649 7.353-20.195 11.472-3.275 2.061-5.943 5.098-8.843 7.743-4.674 4.266-9.342 8.542-13.948 12.882a24.011 24.011 0 00-3.288 3.854c-3.15 4.587-6.206 9.24-9.402 14.025 1.786 1.847 3.41 3.613 5.148 5.259zm28.102-6.271l-11.556 48.823 54.3-34.987-42.744-13.836zm76.631-34.846l-46.15 7.71 15.662 38.096c10.221-15.359 20.24-30.41 30.488-45.806zM44.996 56.644l41.892 13.6c-5.25-12.79-10.32-25.133-15.495-37.737L44.996 56.644zM16.831 75.643L2.169 110.691l27.925-.825-13.263-34.223zm13.593 26.096l.346-.076c3.353-13.941 6.754-27.786 10.177-42.272L18.544 71.035c3.819 9.926 7.891 20.397 11.88 30.704zm84.927-78.897c-4.459-1.181-8.918-2.366-13.379-3.539-6.412-1.686-12.829-3.351-19.237-5.052-.801-.213-1.38-.352-1.851.613-2.265 4.64-4.6 9.245-6.901 13.868-.071.143-.056.328-.111.687l41.47-6.285.009-.292zM89.482 12.288l36.343 10.054-6.005-17.11-30.285 6.715-.053.341zM33.505 114.007c-4.501-.519-9.122-.042-13.687.037-3.75.063-7.5.206-11.25.323-.386.012-.771.09-1.156.506 31.003 2.866 62.005 5.732 93.007 8.6l.063-.414-29.815-4.07c-12.384-1.691-24.747-3.551-37.162-4.982zM2.782 99.994c3.995-9.27 7.973-18.546 11.984-27.809.401-.929.37-1.56-.415-2.308-1.678-1.597-3.237-3.318-5.071-5.226-2.479 12.24-4.897 24.177-7.317 36.113l.271.127c.185-.297.411-.578.548-.897zm78.74-90.153c6.737-1.738 13.572-3.097 20.367-4.613.44-.099.87-.244 1.303-.368l-.067-.332-29.194 3.928c2.741 1.197 4.853 2.091 7.591 1.385z"
                ></path>
              </svg>
              <div class="pl-4 font-medium skill-name">Ruby</div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- <section id="work" class="max-w-screen-xl m-auto px-12 pb-4">
      <h2 class="text-xl font-semibold pb-4">Experience</h2>
      <article>
        <h3>Front End Developer</h3>
        <h4>Blue Sage Solutions</h4>
      </article>
      <article>
        <h3>Technical Admissions Specialist</h3>
        <h4>App Academy</h4>
      </article>
      <article>
        <h3>Volunteer Developer</h3>
        <h4>Break Diving</h4>
      </article>
    </section>
    <section id="education" class="px-12 max-w-screen-xl m-auto pb-10">
      <h2 class="text-xl font-semibold pb-4">Education</h2>
      <article class="flex pb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"
          />
        </svg>
        <h3 class="pl-2 font-medium">App Academy</h3>
        <h4 class="pl-2 font-light">
          Coding Bootcamp for Software Engineering
        </h4>
      </article>
      <article class="flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"
          />
        </svg>
        <h3 class="pl-2 font-medium">Rutgers University</h3>
        <h4 class="pl-2 font-light">B.S. in Biomedical Engineering</h4>
      </article>
    </section> -->
    <section id="contact" class="bg-[#1A1A1D]">
      <div class="flex justify-end items-center p-2">
        <a href="mailto:shreepateldev@gmail.com" target="_blank" class="m-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width="30"
            height="30"
            fill="#e4e4e4"
          >
            <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M0 128C0 92.65 28.65 64 64 64H448C483.3 64 512 92.65 512 128V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V128zM48 128V150.1L220.5 291.7C241.1 308.7 270.9 308.7 291.5 291.7L464 150.1V127.1C464 119.2 456.8 111.1 448 111.1H64C55.16 111.1 48 119.2 48 127.1L48 128zM48 212.2V384C48 392.8 55.16 400 64 400H448C456.8 400 464 392.8 464 384V212.2L322 328.8C283.6 360.3 228.4 360.3 189.1 328.8L48 212.2z"
            />
          </svg>
        </a>
        <a href="https://github.com/RosePatels" target="_blank" class="m-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 496 512"
            width="30"
            height="30"
            fill="#e4e4e4"
          >
            <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
            />
          </svg>
        </a>
        <a
          href="https://www.linkedin.com/in/rosepatels/"
          target="_blank"
          class="m-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            width="30"
            height="30"
            fill="#e4e4e4"
          >
            <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
            />
          </svg>
        </a>
        <a href="https://codepen.io/rosepatels" target="_blank" class="m-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width="30"
            height="30"
            fill="#e4e4e4"
          >
            <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
            />
          </svg>
        </a>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from "vue";
import MobileMenutItem from "./MobileMenutItem.vue";
import MenuItem from "./MenuItem.vue";
// import gsap from "gsap";
const openMobileNav = ref(false);

function toggleMobileNav() {
  if (openMobileNav.value) {
    openMobileNav.value = false;
    document.body.style.overflowY = "visible";
  } else {
    openMobileNav.value = true;
    document.body.style.overflowY = "hidden";
  }
}
</script>

<style scoped lang="scss">
.prompt-bold {
  font-weight: 700;
}

.about-container {
  height: 100vh;
}
.about-pic {
  width: 300px;
  height: 300px;
  border-radius: 50%;
  border: 15px solid #484848;
  padding: 15px;
  background: white;
  opacity: 0.9;
}
.project-container {
  display: grid;
  grid-gap: 10px;
  max-width: 810px;
  grid-auto-rows: 1fr;
  align-items: center;
}

@media (max-width: 768px) {
  .project-container {
    max-width: 410px;
  }
}

.project-info-grid {
  display: grid;
  grid-template-rows: 60px 1fr;
  background: #1e1e21;
  border: 1px solid #36363a;
  color: #a6a6a6;
}

.project-name {
  color: #e4e4e4;
}

.project-info-grid svg:hover {
  fill: #e9b647;
}

.technology-tag {
  color: #e966a0;
  border: 1px solid #e966a0;
}

.in-progress-tag {
  font-size: 14px;
  color: #e9b647;
  border: 1px solid #e9b647;
}

#contact svg:hover {
  fill: #e9b647;
}

.skill-name {
  color: #e4e4e4;
}
</style>
